import { styled } from '@classify/react-core-components/styles';

import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
import Button from '@classify/react-core-components/Button';
import { translate } from '@openclassrooms/translations';
import { ROUTES } from '@openclassrooms/routing';
import { Link } from 'react-router-dom';
import careerIntentUrl from './images/career_intent.svg';
import BaseBlock from '../BaseBlock/BaseBlock';

const Container = styled(Box)(({ theme: { spacing } }) => ({
  display: 'flex',
  gap: spacing(4),
}));

const ImageContainer = styled('div')(({ theme: { breakpoints } }) => ({
  display: 'none',
  [breakpoints.up('md')]: {
    display: 'block',
  },
}));

const CourseNeedLogin = () => (
  <BaseBlock component="aside">
    <Container>
      <ImageContainer>
        <img src={careerIntentUrl} alt="" />
      </ImageContainer>
      <div>
        <Typography component="div" variant="h6" sx={{ marginBottom: 0.5 }}>
          {translate('global.intro_visitor.welcome_oc.title')}
        </Typography>
        <Typography component="div" variant="subheadingSmall">
          {translate('global.intro_visitor.benefice_register.subheading')}
        </Typography>
        <Button
          variant="tertiary"
          component={Link}
          to={ROUTES.AUTH.LOGIN}
          data-event="Navigation|Redirection::Internal|Authentication"
        >
          {translate('global.intro_visitor.single_authentification_button')}
        </Button>
      </div>
    </Container>
  </BaseBlock>
);
export default CourseNeedLogin;
